import { useState, useEffect, useRef } from 'react';
import { TokenState } from '../stores/data/types';

export interface DataChangeFlags {
  isMetricsChanged: boolean;
}

export const useDataChangeDetection = (data: TokenState) => {
  const [isMetricsChanged, setIsMetricsChanged] = useState(false);
  const previousDataRef = useRef<TokenState | null>(null);

  useEffect(() => {
    if (!previousDataRef.current) {
      previousDataRef.current = { ...data };
      return;
    }

    const prev = previousDataRef.current;
    
    let isMetricsChanged = false;
    if (data.statistics && prev.statistics) {
      const prevStats = prev.statistics;
      const currentStats = data.statistics;
      
      isMetricsChanged = (
        prevStats.lastUpdated !== currentStats.lastUpdated
      );
    }

    if (isMetricsChanged) {
      setIsMetricsChanged(true);
      setTimeout(() => setIsMetricsChanged(false), 800);
    }
    
    previousDataRef.current = { ...data };

  }, [data]);

  return { isMetricsChanged };
};
